/* eslint-disable brace-style */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Stack, DetailsList, SelectionMode, Spinner } from '@fluentui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAllPerpetrators } from '../../assets/axios/services'
import { Columns } from '../../assets/consts/Columns'
import PageNavigation from '../styledComponents/PageNavigation'
import StyledButton from '../styledComponents/StyledButton'
import { PerpetratorStyle } from './Perpetrator.style'

export default function PerpetratorList () {
  const style = PerpetratorStyle()
  const navigate = useNavigate()
  const [pagination, setPagination] = useState({})
  const [actionInProgress, setActionInProgress] = useState(false)

  const [data, setData] = useState([])

  const [filter, setFilter] = useState({
    page: 1,
    searchBy: null,
    sortBy: 'created_date',
    sortAsc: false
  })

  const onPageChange = (page: any) => {
    setFilter({ ...filter, page })
  }
  useEffect(() => {
    setActionInProgress(true)
    getAllPerpetrators(filter).then((res) => {
      setData(res.data.items.map((item: any) => ({ ...item, created_date: moment(item.created_date).format('DD.MM.YYYY') })))
      setPagination({
        total: res.data.total,
        page: res.data.page,
        size: res.data.size
      })
      setActionInProgress(false)
    }
    )
  }, [filter])

  let searchTimeout: any = null

  const onSearch = (searchBy: any) => {
    if (searchBy.length > 2) {
      if (searchTimeout) clearTimeout(searchTimeout)
      searchTimeout = setTimeout(() => {
        if (filter.searchBy !== searchBy) {
          setFilter({ ...filter, searchBy })
        }
      }, 1000)
    } else {
      setFilter({ ...filter, searchBy: null })
    }
  }

  const onRender = (item: any, index: any, column: any) => {
    if (column != null) {
      switch (column?.key) {
        case 'moreButton':
          return (
            <Stack style={ style.row } horizontalAlign='end'>
              <StyledButton
          height='20px'
          onClick={ () => {
            navigate(`/perpetrator/${item.id}`)
          } }
          text='Pregledaj'
          />
            </Stack>
          )
        default:
          return (<>{ item[column?.key] }</>)
      }
    }
  }

  return (
    <Stack style={{ maxWidth: '1000px' }}>
      <Stack horizontal style={ style.topRow } horizontalAlign='space-between'>
        <PageNavigation pagination={ pagination } onPageChange={ onPageChange } onSearch={ onSearch }/>
        <StyledButton
        text='Dodaj'
        onClick={ () => { navigate('/perpetrator/new') } }
        />
      </Stack>
      { actionInProgress
        ? <Spinner style={{ paddingTop: '50px' }}/>
        : <> <DetailsList
      onRenderItemColumn={ onRender }
      items={ data }
      columns={
         Columns((sortBy: any) => setFilter({ ...filter, sortBy, sortAsc: !(filter.sortAsc) }),
           filter.sortAsc, filter.sortBy).PerpetratorColumns }
      selectionMode={ SelectionMode.none }
      />
          { data.length === 0 &&
            <Stack horizontal horizontalAlign='center' style={{ userSelect: 'none' }}>
              nema podataka
            </Stack> }
        </>
      }
    </Stack>
  )
}
